import { Routes, Route } from 'react-router-dom';
import { AppShell } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import { useState } from 'react';
import { PDFEditorPage } from './pages/PDFEditorPage';
import { NotFoundPage } from './pages/NotFoundPage';
import { AppHeader } from './components/layout/AppHeader';
import { AppFooter } from './components/layout/AppFooter';
import { MobileMenuProvider } from './contexts/MobileMenuContext';

function App() {
  const isMobile = useMediaQuery('(max-width: 768px)');
  const [mobileMenuState, setMobileMenuState] = useState<{
    pdfFile?: File | null;
    isTopSectionExpanded: boolean;
    onToggleTopSection: () => void;
  } | null>(null);
  
  return (
    <MobileMenuProvider
      pdfFile={mobileMenuState?.pdfFile}
      isTopSectionExpanded={mobileMenuState?.isTopSectionExpanded ?? true}
      onToggleTopSection={mobileMenuState?.onToggleTopSection ?? (() => {})}
    >
      <AppShell
        header={{ height: isMobile ? 50 : 60 }}
        footer={{ height: isMobile ? 30 : 40 }}
        padding={isMobile ? "xs" : "md"}
      >
        <AppShell.Header>
          <AppHeader />
        </AppShell.Header>
        
        <AppShell.Main>
          <Routes>
            <Route path="/" element={<PDFEditorPage onMobileMenuStateChange={setMobileMenuState} />} />
            <Route path="/pdf-editor" element={<PDFEditorPage onMobileMenuStateChange={setMobileMenuState} />} />
            <Route path="/404" element={<NotFoundPage onMobileMenuStateChange={setMobileMenuState} />} />
            <Route path="*" element={<NotFoundPage onMobileMenuStateChange={setMobileMenuState} />} />
          </Routes>
        </AppShell.Main>
        
        <AppShell.Footer>
          <AppFooter />
        </AppShell.Footer>
      </AppShell>
    </MobileMenuProvider>
  );
}

export default App;
